import { createSelector } from 'reselect';
import { ArmyListUnitCreateView } from './view/ArmyListUnitCreateView';
import { availableUnits } from './availableUnits';
import { AppState } from '@Redux/store';

const getArmyListUnitIsLoading = (state: AppState): boolean => {
  return state.armyListUnit.isLoading;
};

const getOrganisationId = (
  _: AppState,
  props: { organisationId?: number | string },
): number | null => {
  return props?.organisationId ? parseInt(`${props.organisationId}`) : null;
};

export const CreateArmyListUnitPresenter = createSelector(
  [getArmyListUnitIsLoading, availableUnits, getOrganisationId],
  (armyListUnitLoading, units, organisationId): ArmyListUnitCreateView => {
    return new ArmyListUnitCreateView({
      units: units.filter((u) => !organisationId || u.id === organisationId),
      isLoading: armyListUnitLoading,
      canSubmit: !armyListUnitLoading,
    });
  },
);
